module.exports = __webpack_public_path__ + "img/fontumi-happy.d729e378.jpg";